import { DependencyList, useEffect, useState } from 'react';

export interface AsyncState<T> {
  data: T | undefined;
  error: Error | undefined;
  loading: boolean;
}

/// Minimal cancellable fetch hook. No retries, no cache — pages call list/get
/// endpoints once per mount; if you need invalidation, bump a counter dep.
export function useAsync<T>(fn: () => Promise<T>, deps: DependencyList): AsyncState<T> {
  const [state, setState] = useState<AsyncState<T>>({ loading: true, data: undefined, error: undefined });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, data: undefined, error: undefined });
    fn()
      .then((data) => {
        if (!cancelled) setState({ loading: false, data, error: undefined });
      })
      .catch((error: Error) => {
        if (!cancelled) setState({ loading: false, data: undefined, error });
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}
